module.exports = __webpack_public_path__ + "img/facebook.cf3638b4.svg";